import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useDispatch, useSelector } from "react-redux";
import {
   GetQuotaChartData,
   SaveQuota,
   Upload,
   exportFile,
   reset,
   setLoadData,
   setQuotaObject,
   setState,
} from "./defineSlice";
import {
	catchElement,
	elementToBase64,
	mergeExportQuotaCustomerRow,
	prepareCustomers,
	scenarioExportOmitsRowDepletionType,
} from "./defineUtils";

const style = {
   position: "absolute",
   top: "20%",
   left: "50%",
   transform: "translate(-50%, -50%)",
   width: 500,
   bgcolor: "background.paper",
   boxShadow: 24,
   p: 2,
};

export default function ExportDataModal() {
   const dispatch = useDispatch();
   const define = useSelector((state) => state.define);
   const {
      exportDataModalOpen,
      quotaChartData,
      selectedQuota,
      selectedCountry,
      selectedPeriod,
      selectedDepletion,
      selectedScenario,
      selectedProduct,
      exportPdf,
      gridData,
      gridDataFiltered,
      showChart,
      quotaChartColumns,
      isWeek4Only,
      selectedDepletionPeriodType,
   } = define;

   function closeExportDataModal() {
      dispatch(setState("exportDataModalOpen", false));
   }

   async function handleExportFile(yesClicked) {
      closeExportDataModal();
      if (yesClicked) {
         saveQuota();
      }
      else {
         await exportDataAsFile(exportPdf, false);
      }
   }

   function saveQuota() {
      dispatch(Upload({ method: "POST" })).then(() => {
         dispatch(setQuotaObject({ method: "saveQuota" }));
         dispatch(SaveQuota({ method: "POST" })).then((response) => {
            if (response.payload !== "error") {
               dispatch(reset("onAllocateClick"));
               dispatch(setLoadData());
               dispatch(GetQuotaChartData({ method: "POST" }));
               exportDataAsFile(exportPdf, true);
            }
         });
         dispatch(setState("saveOrSubmitError", 0));
      });
   }

   async function exportDataAsFile(isPdf, yesClicked) {
      console.log("SELECTED QUOTA", selectedQuota);
      let quotaCustomers = [];
      if(selectedQuota.listQuotaCustomers.length > 0) {
         quotaCustomers = selectedQuota.listQuotaCustomers.slice();
      }
      else {
         let array = JSON.parse(JSON.stringify(selectedQuota.listQuotaCustomers2));
         let joinedArray = array.map(item1 => {
            let item2 = gridData.find(item => item.skuid === item1.skuid && item.customerID === item1.customerID
               && item.customerGroupID === item1.customerGroupID && item.productGroupID === item1.productGroupID);
            return {
               ...item1,
               name: item2.name,
               packName: item2.packName,
               skuNumb: item2.skuNumb,
               customerNumber: item2.customerNumber,
               depletionModel: item2.depletionModel,
               depletionModelName: item2.depletionModelName,
            };
        });
        quotaCustomers = joinedArray;
      }
      if(yesClicked) {
         let customers = prepareCustomers(gridData, gridDataFiltered);
         quotaCustomers = customers;
      }
      console.log("QUOTA CUSTOMERS LENGTH", quotaCustomers.length);
      console.log("QUOTA CUSTOMERS", quotaCustomers);
      const omitRowDepletionType = scenarioExportOmitsRowDepletionType(selectedScenario);
      const list = quotaCustomers.map((item) =>
         mergeExportQuotaCustomerRow(item, gridData, isWeek4Only, omitRowDepletionType)
      );

      const elem = catchElement(".DefineQuotaChart");
      const elemBase64 = await elementToBase64(elem);

      const graphTableData = quotaChartData.map((item) => {
         return item[0];
      });

      let payload = {
         countryId: selectedCountry.countryID,
         countryName: selectedCountry.countryName,
         displayDate: selectedPeriod.displayDate,
         effectiveEndDate: selectedPeriod.endDate,
         effectiveStartDate: selectedPeriod.startDate,
         isWeekly: selectedDepletion.value.includes("weekly"),
         scenarioID: selectedScenario.scenarioID,
         scenarioName: selectedScenario.scenarioName,
         selectedProduct: selectedProduct.packGroupOrSKUName,
         listQuotaCustomers3: list,
         chartImage: elemBase64,
         depletionType: selectedDepletion.key,
         weeklyDepletion: selectedDepletion.key,
         depletionPeriodDisplay:
            selectedDepletionPeriodType?.depletionPeriodType ??
            "",
         scenarioPeriodType: selectedScenario?.periodType ?? "",
         // graphTableCol: quotaChartColumns.slice(1),
         // graphTableData: graphTableData,
      };
      if(showChart === false) {
         let chartCols = quotaChartColumns.slice();
         let graphTableCol = ["Data"];
         for(let i = 0; i < graphTableData.length; ++i) {
            let item = graphTableData[i];
            graphTableCol.push(item.split(",")[0]);
         }

         if(chartCols[0] === "Series") {
            chartCols.shift();
         }

         let graphTableColList = [];
         for(let i = 0; i < graphTableData.length; ++i) {
            let list = graphTableData[i].split(",");
            list = list.slice(1);
            list = list.map(item => item === "null" ? "" : item);
            graphTableColList.push(list);
         }
         let graphTableData_ = [];
         for(let i = 0; i < chartCols.length; ++i) {
            let list = [chartCols[i]];

            for(let j = 0; j < graphTableColList.length; ++j) {
               list.push(graphTableColList[j][i]);
            }
            graphTableData_.push(list);
         }
         console.log("graphTableCol", graphTableCol);
         console.log("graphTableData", graphTableData_);

         payload = {
            ...payload,
            graphTableCol,
            graphTableData: graphTableData_
         };
      }

      const obj = {
         isPdf,
         payload,
         displayType: showChart ? "graph" : "table"
      };

      console.log("Define_ExportData_exportDataAsFile", obj);
      dispatch(exportFile(obj));
   }

   return (
      <div>
         <Modal
            open={exportDataModalOpen}
            onClose={closeExportDataModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
         >
            <Box sx={style}>
               <Typography id="modal-modal-title" variant="h6" component="h2">
                  Changes Detected
               </Typography>
               <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  Only saved information will be exported. Do you want to save
                  before exporting?
               </Typography>

               <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
                  <Button
                     sx={{
                        bgcolor: "grey.lighter",
                        color: "darkred.light",
                        fontWeight: "600",
                        "&:hover": {
                           bgcolor: "darkred.main",
                           color: "white.main",
                        },
                     }}
                     variant="contained"
                     size="small"
                     onClick={closeExportDataModal}
                  >
                     Close
                  </Button>

                  <Button
                     sx={{
                        bgcolor: "darkred.light",
                        color: "white.main",
                        fontWeight: "600",
                        ml: 1,
                        "&:hover": {
                           bgcolor: "darkred.main",
                        },
                     }}
                     variant="contained"
                     size="small"
                     onClick={(e) => handleExportFile(true)}
                  >
                     Yes
                  </Button>

                  <Button
                     sx={{
                        bgcolor: "darkred.light",
                        color: "white.main",
                        fontWeight: "600",
                        ml: 1,
                        "&:hover": {
                           bgcolor: "darkred.main",
                        },
                     }}
                     variant="contained"
                     size="small"
                     onClick={(e) => handleExportFile(false)}
                  >
                     No
                  </Button>
               </Box>
            </Box>
         </Modal>
      </div>
   );
}
